import type { ExternalTableSchema } from '@packages/table-builder';

export const userDefinedFieldsTable: ExternalTableSchema = {
  metadata: {
    title: 'User Defined Fields',
    entity: 'UserDefinedFields',
  },

  dataSource: {
    endpoint: '/api/customer/api/app/user-defined-fields/user-defined-fields-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      ModuleId: 'filters.moduleId',
      StatusId: 'filters.statusId',
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'moduleId',
        placeholder: 'Module',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/user-defined-fields/user-defined-modules',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'statusId',
        placeholder: 'Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/user-defined-fields/user-defined-status',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'fieldName',
      header: 'Field Name',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'fieldType',
      header: 'Field Type',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'isMandatory',
      header: 'Field Property',
      type: 'text',
      width: 200,
      conditionalValues: { true: 'Mandatory', false: 'Non-mandatory' },
    },
    {
      field: 'orderNumber',
      header: 'Order Number',
      type: 'number',
      align: 'center',
      width: 180,
      format: { commas: true },
      emptyDisplay: '-',
    },
    {
      field: 'modules',
      header: 'Module',
      type: 'custom',
      renderer: 'udfModulesMultiline',
      sortable: true,
      width: 150,
    },
    {
      field: 'description',
      header: 'Description',
      type: 'text',
      width: 180,
      visibility: 'picker',
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      sortable: true,
      align: 'center',
      width: 150,
      conditionalValues: { '1': 'Active', '2': 'Inactive' },
      badge: { statusMap: { '1': 'success', '2': 'error' }, defaultVariant: 'info' },
    },
  ],

  actions: {
    toolbar: {
      primary: {
        id: 'ADD_USER_DEFINED_FIELDS',
        label: 'Add User Defined Field',
        icon: 'add_circle_outline',
      },
    },
    row: [
      { id: 'EDIT_USER_DEFINED_FIELDS', label: 'Edit' },
      { id: 'DELETE_USER_DEFINED_FIELDS', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'UDF', resizable: true, reorderable: true },
  },
};
